import InputWrapper from "../../../../../../../components/input/wrapper/InputWrapper";
import MultiSelect from "../../../../../../../components/select/main/multi/MultiSelect";
import { useLanguageContext } from "../../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../../helpers/EVAApiHelper";
import { StyledFlexColumn } from "../../../../../../../styles/LayoutStyles";
import FontForm from "../../default/font/FontForm";
import PositionForm from "../../default/position/PositionForm";
import SizeForm from "../../default/size/SizeForm";

function FieldValuesFormView({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
  fields,
  onFieldsChange,
}) {
  const { translate, translateEntity } = useLanguageContext();

  return (
    <StyledFlexColumn>
      {/* Position */}
      <PositionForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Size */}
      <SizeForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Font */}
      <FontForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      <InputWrapper
        label={translate("eva.main.validation.attributes.label_items.*.fields")}
        required
        error={EVAApiHelper.getResponseErrorArray(
          `label_items.${selectedLabelItemIndex}.fields`,
          submitError
        )}
      >
        <MultiSelect
          options={fields.map((field) => ({
            value: field.id,
            label: translateEntity(field, "label"),
          }))}
          value={selectedLabelItem.fields}
          onChange={onFieldsChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default FieldValuesFormView;
